import React from "react";
import { ORIGINS } from "@/home/content";

/*
 * Editorial routes diagram: origin nodes converging on India through fine
 * champagne-gold lines. Deliberately abstract — no glowing tech dashboard.
 */
const NODE_X = 150;
const INDIA = { x: 640, y: 262 };
const START_Y = 58;
const GAP = 37;

export const WorldRoutes = ({ animated = true }) => (
  <svg
    viewBox="0 0 760 520"
    className="w-full h-auto"
    role="img"
    aria-label="Portfolio origins: routes from twelve countries converging on India"
  >
    {ORIGINS.map((name, i) => {
      const y = START_Y + i * GAP;
      const c1x = NODE_X + (INDIA.x - NODE_X) * 0.45;
      const c1y = y + (INDIA.y - y) * 0.15;
      return (
        <g key={name}>
          <text
            x={NODE_X - 16}
            y={y + 3.5}
            textAnchor="end"
            className="fill-[#F7F1E7]/75"
            style={{ font: "500 11px Manrope, sans-serif", letterSpacing: "0.18em", textTransform: "uppercase" }}
          >
            {name}
          </text>
          <circle cx={NODE_X} cy={y} r="2.4" className="fill-[#C7A45D]" />
          <path
            d={`M ${NODE_X + 6} ${y} Q ${c1x} ${c1y} ${INDIA.x - 14} ${INDIA.y}`}
            fill="none"
            stroke="#C7A45D"
            strokeWidth="0.8"
            strokeOpacity="0.4"
            strokeDasharray="3 7"
            className={animated ? "hcc-dash" : ""}
            style={animated ? { animationDelay: `${i * 0.35}s` } : undefined}
          />
        </g>
      );
    })}
    <circle cx={INDIA.x} cy={INDIA.y} r="5" className="fill-[#C7A45D]" />
    <circle cx={INDIA.x} cy={INDIA.y} r="12" fill="none" stroke="#C7A45D" strokeOpacity="0.45" strokeWidth="0.8" />
    <circle cx={INDIA.x} cy={INDIA.y} r="20" fill="none" stroke="#C7A45D" strokeOpacity="0.2" strokeWidth="0.8" />
    <text
      x={INDIA.x}
      y={INDIA.y + 44}
      textAnchor="middle"
      className="fill-[#F7F1E7]"
      style={{ font: "600 13px Manrope, sans-serif", letterSpacing: "0.35em" }}
    >
      INDIA
    </text>
  </svg>
);
